import React, { useState } from 'react';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';


function TpBody() {


  // 変更する
  // ---------------------------------------------
  // 2022.4.28
  // 921,4605(sum,cost)

  const roundPointInit = 31509.41176470588 / 5; // 1試合獲得pt(ボーナス前)
  const drinkPoint = 150000

  const [bonus, setBonus] = useState(500);
  const [round, setRound] = useState(roundPointInit);

  const roundPointBonus = round * (1 + bonus / 100); // 1周獲得pt(ボーナス後)


  // 表示設定
  // ---------------------------------------------
  // const [digits, setDigits] = useState(0);
  const digits = 0;
  const [object, setObject] = useState(30000000);
  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------


  // ---------------------------------------------

  const energy = object / roundPointBonus


  //  獲得ドリンク本数
  const drink = Math.floor((energy * round) / drinkPoint) * 3



  //   消費エナジー変更
  const handleObjectChange = (event) => {
    setObject(event.target.value);
  };

  const handleBonusChange = (event) => {
    setBonus(event.target.value);
  };

  const handleRoundChange = (event) => {
    setRound(event.target.value);
  };

  return (
    <>
      <Base body={
        <Container>
          <h1>ターニングポイント</h1>
          <Label>
            <Text>目標Pt：</Text>
            <Input type="number" value={object} onChange={handleObjectChange} />
          </Label>
          <Label>
            <Text>ボーナス(％)：</Text>
            <Input type="number" value={bonus} onChange={handleBonusChange} />
          </Label>
          <Label>
            <Text>1試合獲得Pt：</Text>
            <Input type="number" value={Math.ceil(round)} onChange={handleRoundChange} />
          </Label>
          <Result>
            <p>{Math.ceil(energy) - drink}エナジー必要です。</p>
          </Result>
        </Container>
      } title="TP" />
    </>
  );
}

export default TpBody;
